import React from "react";
import { extractPolylineFromWKT } from "../../services/shared";
import { Polyline } from "react-leaflet";
import polylineColors from "../shared/map-polyline-colors";

/**
 * Used to generate polylines based on the passed parameters.
 * @component
 * @category Components
 * @subcategory Map
 * @param {array} data  contains polyline strings
 * @param {string} type the color of the polyline is determined based on it
 * @param {line} line the line string used to determine the corresponding transport line
 */
const MapPolylines = ({ data, type, line }) => {
  return data.map((el) => {
    return (
      <React.Fragment key={el.lngLatStrings ? el.id : el.startStop + "-" + el.endStop}>
        <Polyline
          positions={el.lngLatStrings ? extractPolylineFromWKT(el.lngLatStrings) : extractPolylineFromWKT(el.wkt, true)}
          color={polylineColors[type]}
          weight={5}
          line={line}
        />
      </React.Fragment>
    );
  });
};

export default React.memo(MapPolylines);
